import React from 'react';

const SubscriptionStatus = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80vh',
      textAlign: 'center',
      padding: '20px',
      fontFamily: 'Helvetica Neue, sans-serif'
    }}>
      <div style={{
        background: '#f0fdf4',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.05)'
      }}>
        <div style={{ color: '#22c55e', marginBottom: '20px' }}>
          {/* Large green checkmark */}
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>

        <h1 style={{ fontSize: '28px', color: '#1a1a1a', marginBottom: '10px' }}>
          Subscription Confirmed!
        </h1>
        <p style={{ color: '#666', fontSize: '18px', maxWidth: '400px', lineHeight: '1.6' }}>
          Thank you for verifying your email. You are now officially part of the 
          <strong> Kanha Wondercraft</strong> family.
        </p>

        <a href="/" style={{
          marginTop: '30px',
          display: 'inline-block',
          backgroundColor: '#245689',
          color: '#fff',
          padding: '12px 30px',
          borderRadius: '50px',
          textDecoration: 'none',
          fontWeight: 'bold',
          transition: 'transform 0.2s'
        }}>
          Explore Our Collection
        </a>
      </div>
    </div>
  );
};

export default SubscriptionStatus;